<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '媒体邀约')[0].value">
    <div style="height: 75%;width: 85%;margin-top: 1%;" >
        <div v-if="mediaShow" style="display: flex;  width: 100%;height: 100%; justify-content: flex-start;
  flex-wrap: wrap;">
          <el-card  class="mediaitem"
            v-for="(o, i) in AllMedia"
            :key="i" >
            <el-tooltip
                :content="o.name"
                placement="bottom"
                effect="light">
                <img
                :src="Global.imgip+o.icon"
                class="hand"
                @click="Details(o)"
                />
            </el-tooltip>
         </el-card>
        </div>
          <div v-if="mediaview">
            <div style="text-align: center;margin-bottom: 10px;">
                <h3>{{ Mediaform.name }}</h3>
            </div>
            <div style="margin-bottom: 10px;">
                <span>{{ Mediaform.describe }}</span>
            </div>
            <div >
                <el-form :model="mediaForm" ref="mediaForm" :rules="rules" label-width="120px">
                              <el-form-item label="成本:" prop="cost">
                                <span>{{String(Mediaform.cost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}&nbsp;元</span>
                              </el-form-item>
                              <el-form-item label="邀约方式:" :required="mediaWay" prop="mediaWay">
                                <el-select  :disabled="isdisabled"
                                    size="medium" v-model="mediaForm.mediaWay">
                                        <el-option v-for="item in MediaWayList"
                                            :key="item.name"
                                            :label="item.name"
                                            :value="item.id"></el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item>
                                <el-button type="primary" @click="onsubmit()" >{{
                                                                      SModelMediaList.filter(
                                                                        (t) =>
                                                                          t.state != Global.SModel.Delete && t.mediaID==Mediaform.id
                                                                      ).length > 0
                                                                        ? "取消"
                                                                        : "确定"
                                                                    }}</el-button>
                              </el-form-item>
                            </el-form>
            </div>
          </div>
    </div>
  </ShowControl>
</template>

<script>
  import { mapState } from "vuex";
  import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["mediaClose"],
  components: {
    ShowControl
  },
    data()
    {
        return {
          flowID: localStorage.getItem("flowID"),
          caseID: localStorage.getItem("caseId"),
            AllMedia:[],
            mediaview:false,
            SModelMediaList:[],
            ExhibitionPlanningList:[],
            ExhibitionPlanning:{},
            Mediaform: {},
            mediaForm:{
                mediaWay:0,
                number:1
            },
            isdisabled:false,
            mediaShow: true,
            rules:{
                mediaWay: [{ required: true, message: "请选择邀约方式", trigger: "blur" }],
                number: [{ required: true, message: "请输入数量", trigger: "blur" }],
            },
            MediaWayList:[{name:'邮件',id:0},{name:'短信',id:1}],
            childTitle: '',
            title: '媒体邀约',
        }
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
        MarketCost: (state) => state.user.marketCostStatistics,
      }),
    },
    mounted() {
        this.GetAllMedia();
        this.GetSModelPlan();
        this.$refs.showControl.receiveValue(true);
    },
    methods: {
      revertClick(){
        this.$router.push("/MiceMarketing")
      },
        GetAllMedia() {
            this.$http.get("Media/GetAllMedia?caseID="+this.caseID).then((res) => {
                if (res.success) {
                this.AllMedia = res.dynamicObj;
                } else {
                this.$message.error(res.message);
                }
            });
        },
        Details(Mediaform){
          // this.$emit('Mediaform',Mediaform)
          this.$router.push({path:'MediaDeatilCard',query:{ id : Mediaform.id }})
        },
        reverts(){
          this.childTitle = ''
          this.mediaShow=true
          this.mediaview = false;
        },
        GetSModelPlan () {
        this.$http
          .get(
            "SModel/GetTypeSModel?round=" +
            this.Round +
            "&typename=S_ExhibitionPlanning"
          )
          .then((res) => {
            if (res.success) {
              this.ExhibitionPlanningList = res.dynamicObj;
              if(this.ExhibitionPlanningList.filter(c=> c.state != this.Global.SModel.Delete).length>0){
                this.ExhibitionPlanning = this.ExhibitionPlanningList.filter(c=> c.state != this.Global.SModel.Delete)[0];
              }         
            } else {
              return this.$message.error(res.message);
            }
          });
        },
        GetSModelMedia () {
        this.$http
          .get(
            "SModel/GetTypeSModel?round=" +
            this.Round +
            "&typename=S_Media"
          )
          .then((res) => {
            if (res.success) {
              this.SModelMediaList = res.dynamicObj;
              if(this.SModelMediaList.filter(c=> c.state != this.Global.SModel.Delete && c.mediaID==this.Mediaform.id).length>0){
                this.isdisabled=true;
                this.mediaForm = this.SModelMediaList.filter(c=> c.state != this.Global.SModel.Delete && c.mediaID==this.Mediaform.id)[0];
              } else
              {
                this.isdisabled=false;
                this.mediaForm.mediaWay=0;
              }           
            } else {
              return this.$message.error(res.message);
            }
          });
        },
        onsubmit(){
          if(this.flowID != this.Global.FlowList.招商)
          {
            this.$message.error("当前流程阶段不是招商，无法进行操作！");
            return;
          }
          let that=this;
          that.$refs.mediaForm.validate((valid) => {
            if (valid) {
              let list=that.SModelMediaList.filter(c=>c.mediaID==this.Mediaform.id);
              // if(list.filter(c=>c.state!= this.Global.SModel.Delete).length>0&&list.filter(c=> c.state != this.Global.SModel.Delete && c.mediaID==this.Mediaform.id).length == 0)
              // {
              //   that.$message.error("当前已进行邀约，无需重复邀约");
              //   return;
              // }
              var cost=this.Mediaform.cost * this.mediaForm.number;
              if(list.filter(c=>c.state!=that.Global.SModel.Delete).length > 0)
              {
                list[0].state=that.Global.SModel.Delete;
                that.$http
                  .post("SModel/PushStrategy", that.Global.getsmodel(list))
                  .then((res) => {
                    if (res.success) {
                      this.Global.GetBudget(-cost);
                      that.Global.sendmsgmd(
                          "会展营销",
                          `取消了${this.Mediaform.name}媒体邀约，增加了${cost}元`,
                          1
                        );
                      var incomet=[{
                        buissType:that.Global.PayType.媒体邀约成本,
                        round:this.Round,
                        buissId:this.Mediaform.id
                      }];
                      that.API.pushIncomet(incomet,1);
                      that.GetSModelMedia();
                      that.$store.commit("marketStatistics", !this.MarketCost);  
                      that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.delete,'媒体邀约');
                    } else {
                      that.$message.error(res.message);
                      return false;
                    }
                  });
              }else
              {
                if (!this.Global.GetBudget(cost)) {
                    this.$message.error("资金不足");
                    return;
                }
                if(list.length==0)
                {
                  list=[];
                  list.push(that.mediaForm)
                  list[0].uuid= that.uuid.guid();
                  list[0].state=that.Global.SModel.Create;
                }else
                {
                  let uuid=list[0].uuid;
                  list=[];
                  list.push(that.mediaForm)
                  list[0].state=that.Global.SModel.Update;
                  list[0].uuid= uuid;
                }
              list[0].round= that.Round;
              list[0].type="S_Media";
              list[0].sTTime= that.filter.formatDate(new Date());
              list[0].mediaID=this.Mediaform.id;
              list[0].cost=cost;
              that.$http
                  .post("SModel/PushStrategy", that.Global.getsmodel(list))
                  .then((res) => {
                    if (res.success) {
                      that.Global.sendmsgmd(
                          "会展营销",
                          `操作了${this.Mediaform.name}媒体邀约，扣减了${cost}元`,
                          1
                        );
                        var incomet=[{
                        buissType:that.Global.PayType.媒体邀约成本,
                        buissValue:cost,
                        name:'媒体邀约成本',
                        describe:'',
                        round:this.Round,
                        buissId:this.Mediaform.id
                      }];
                      that.API.pushIncomet(incomet,0);
                      that.GetSModelMedia();
                      that.$store.commit("marketStatistics", !this.MarketCost);  
                      that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.normal,'媒体邀约');
                    } else {
                      that.$message.error(res.message);
                      return false;
                    }
                  });
              }
              
            }
          });
         
        },
    },
}
</script>

<style lang="scss" scoped>
.mediaitem {
  width: 12%;
  height: 28%;
  border-radius: 10%;
  overflow: hidden;
  margin: calc(100vw * 5 / 1920) calc(100vw * 15 / 1920);
  // background-color: rgb(230, 98, 98);
  transform: scale(1);
  transition: all 0.6s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mediaitem:hover {
  transform: scale(1.2);
}
.hand {
  cursor: pointer;
  width: 100%;
  height: 100%;
}
// .inputs{
//     width: 220px;
// }
</style>